module.exports = __webpack_public_path__ + "img/parking_2.df57b6f8.jpeg";